// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
// Turbolinks.start()
ActiveStorage.start()

require("@popperjs/core")
require("jquery")
require("easy-autocomplete")
require("packs/searches")
require("packs/home_typing_headline")

import "bootstrap"

// Import the specific modules you may need (Modal, Alert, etc)
import { Tooltip, Popover, Badge, Collapse, Navbar } from "bootstrap"

import 'packs/choices';
import 'packs/components/caret';

// The stylesheet location we created earlier
require("../stylesheets/application.scss")

// ------------------------------------------------------------
// UI helpers
// ------------------------------------------------------------

/**
 * Initialise (or re-initialise) all Bootstrap tooltips & popovers that
 * exist in the current DOM. We expose this on `window` so that other
 * scripts – like `products/refresh.js.erb` – can call it whenever they
 * inject fresh HTML via AJAX.
 */
window.initializeTooltipsAndPopovers = function () {
  // Tooltips
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  )
  tooltipTriggerList.forEach(function (el) {
    if (!Tooltip.getInstance(el)) {
      new Tooltip(el)
    }
  })

  // Popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  )
  popoverTriggerList.forEach(function (el) {
    if (!Popover.getInstance(el)) {
      if (el.classList.contains("qty-stepper")) {
        new Popover(el)
        return
      }

      var popover = new Popover(el, {
        trigger: "click",
        container: el.closest(".modal") || document.body
      })

      el.setAttribute("aria-haspopup", "dialog")
      el.setAttribute("aria-expanded", "false")

      el.addEventListener("inserted.bs.popover", function () {
        var tip = document.getElementById(el.getAttribute("aria-describedby"))
        if (!tip) return

        tip.classList.add("popover--dismissible")
        tip.setAttribute("role", "dialog")
        tip.setAttribute("aria-label", "Additional information")

        if (tip.querySelector(".popover-close")) return

        var close = document.createElement("button")
        close.type = "button"
        close.className = "popover-close"
        close.setAttribute("aria-label", "Close information")
        close.textContent = "\u00d7"
        close.addEventListener("click", function () {
          popover.hide()
          el.focus()
        })
        tip.appendChild(close)
      })

      el.addEventListener("shown.bs.popover", function () {
        var tip = document.getElementById(el.getAttribute("aria-describedby"))
        if (!tip || !tip.classList.contains("show")) return

        el.setAttribute("aria-expanded", "true")
        tip.querySelector(".popover-close").focus()
      })

      el.addEventListener("hide.bs.popover", function () {
        el.setAttribute("aria-expanded", "false")
      })
    }
  })
}

/**
 * Dispose the tooltips & popovers inside `root` before its HTML is replaced:
 * Bootstrap keeps an open tip in <body>, so a removed trigger would strand it.
 */
window.disposeTooltipsAndPopovers = function (root) {
  root.querySelectorAll('[data-bs-toggle="tooltip"], [data-bs-toggle="popover"]').forEach(function (el) {
    var instance = Tooltip.getInstance(el) || Popover.getInstance(el)
    if (instance) instance.dispose()
  })
}

/**
 * Smooth-scroll so `target` lands just below the fixed header, which grows
 * when the announcement bar is on.
 */
window.scrollBelowHeader = function (target, duration, complete) {
  var headerBottom = document.querySelector('.dash-toolbar').getBoundingClientRect().bottom

  $('html, body').animate({ scrollTop: $(target).offset().top - headerBottom - 16 }, duration, complete)
}

// ------------------------------------------------------------------
// On initial page load
// ------------------------------------------------------------------

jQuery(function () {
  Rails.refreshCSRFTokens()
  initializeTooltipsAndPopovers()
})

// ------------------------------------------------------------------
// Close any open popover when the user clicks outside of it or opens another.
// ------------------------------------------------------------------

document.addEventListener("click", function (e) {
  var target = e.target

  if (target.closest(".popover")) return

  var trigger = target.closest('[data-bs-toggle="popover"]')

  document
    .querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(function (el) {
      if (el === trigger) return
      var instance = Popover.getInstance(el)
      if (instance) {
        instance.hide()
      }
    })
})

document.addEventListener("keydown", function (e) {
  if (e.key !== "Escape") return

  var tip = document.querySelector(".popover.show")
  if (!tip) return

  var trigger = document.querySelector('[data-bs-toggle="popover"][aria-describedby="' + tip.id + '"]')
  if (!trigger) return

  e.stopPropagation()
  Popover.getInstance(trigger).hide()
  trigger.focus()
}, true)

// ------------------------------------------------------------------
// Re-initialise tooltips & popovers after any AJAX request completes.
// This covers the product refresh that swaps partials via JS.
// ------------------------------------------------------------------

$(document).ajaxComplete(function () {
  initializeTooltipsAndPopovers()
})

// thngs being affected by turbo: select, ripple click, learn more collapse, faq, click on image bug
import "controllers"

window.initMap = function(...args) {
  const event = document.createEvent("Events")
  event.initEvent("google-maps-callback", true, true)
  event.args = args
  window.dispatchEvent(event)
}
